import { createContext, useContext } from "react";

/**
 * Holds a pre-loaded report snapshot. When a snapshot is present, report pages
 * must read their data from it instead of fetching (used by the public page
 * that the PDF renderer opens). `null` means "live" mode.
 */
const ReportSnapshotContext = createContext(null);

export const ReportSnapshotProvider = ({ snapshot, children }) => (
  <ReportSnapshotContext.Provider value={snapshot}>
    {children}
  </ReportSnapshotContext.Provider>
);

export const useReportSnapshot = () => useContext(ReportSnapshotContext);
